import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './shared/templates/layout/layout.component';
import { getConfirmationDi } from '@cfg/services/confirmation-di';
import { getNotificationDi } from '@cfg/services/notification-di';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { getTranslationDi } from '@cfg/i18n/translation-di';
import { getDialogDi } from '@cfg/services/dialog-di';

/**
 * Componente inicial de la aplicación, aquí se carga el router-outlet
 */
@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    ToastModule,
    ConfirmDialogModule,
    DynamicDialogModule,
    LayoutComponent
  ],
  providers: [
    getConfirmationDi,
    getNotificationDi,
    getTranslationDi,
    getDialogDi
  ],
  template: ` <app-layout></app-layout> <p-confirmDialog /> <p-toast />`,
  styles: []
})
export class AppComponent implements OnInit, OnDestroy {
  /**
   * Crea una instancia de AppComponent.
   * @param _elementRef Referencia al elemento del componente.
   */
  constructor(private readonly _elementRef: ElementRef) {}

  /**
   * Inicializa el componente y elimina el atributo ng-version del elemento
   */
  ngOnInit(): void {
    (this._elementRef.nativeElement as HTMLElement).removeAttribute(
      'ng-version'
    );
    document.addEventListener('input', this._uppercaseOnCapture, true);
  }

  ngOnDestroy(): void {
    document.removeEventListener('input', this._uppercaseOnCapture, true);
  }

  private readonly _uppercaseOnCapture = (event: Event): void => {
    const target = event.target as HTMLInputElement;
    if (target.tagName !== 'INPUT') {
      return;
    }

    if (target.dataset['noUppercase'] !== undefined) {
      return;
    }

    const type = target.type?.toLowerCase();
    if (type && type !== 'text') {
      return;
    }

    const upper = target.value.toUpperCase();
    if (target.value === upper) {
      return;
    }

    const start = target.selectionStart;
    const end = target.selectionEnd;
    target.value = upper;
    target.setSelectionRange(start, end);
  };
}
